/**
 * Product Data with i18n support
 * 
 * This file provides product data functions that read from i18n translations
 */

// This function should be called with the translation function from useTranslation
export const getProductInfo = (t) => ({
  name: t('conectados.title'), // Reusing existing key
  title: t('conecta2Product.hero.title'),
  subtitle: t('conecta2Product.hero.subtitle'),
  description: t('conecta2Product.meta.description'),
});

export const getPricing = (t) => ({
  mercadopago: {
    price: t('conecta2Product.price.mercadopago.price'),
    label: t('conecta2Product.price.mercadopago.label'),
    detail: t('conecta2Product.price.mercadopago.detail'),
  },
  transferencia: {
    price: t('conecta2Product.price.transferencia.price'),
    originalPrice: t('conecta2Product.price.transferencia.originalPrice'),
    label: t('conecta2Product.price.transferencia.label'),
    detail: t('conecta2Product.price.transferencia.detail'),
    discount: t('conecta2Product.price.transferencia.discount'),
  },
});

export const getIncludes = (t) => t('conecta2Product.includes.items');

export const getHowToPlaySteps = (t) => t('conecta2Product.howToPlay.steps');

export const getFAQs = (t) => t('conecta2Product.faq.items');

export const getTestimonial = (t) => ({
  title: t('conecta2Product.testimonial.title'),
  text: t('conecta2Product.testimonial.text'),
  quote: t('conecta2Product.testimonial.quote'),
});

export const getWhatsAppConfig = (t) => ({
  phoneNumber: '59895454544',
  messageTemplate: (paymentMethod) =>
    t('conecta2Product.price.whatsappMessage.reserve').replace('{paymentMethod}', paymentMethod),
  paymentInfoMessage: t('conecta2Product.price.whatsappMessage.paymentInfo'),
});
